import styled, { css } from 'styled-components';

// Constellation
import { Text, token } from '@zillow/constellation';

export const CardContainer = styled.div<{ isHovered: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 168px;
  height: 100%;
  border-radius: 8px;
  border: solid 2px ${token('colors.brand')};

  background-color: ${({ isHovered }) =>
    css`
      ${isHovered ? token('colors.blue200') : token('colors.white')}
    `};
`;

export const CardAddress = styled.div<{ height: number | null }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${({ height }) => (height ? `${height}px;` : '105px;')}
  width: 100%;
`;

export const MyPropertyHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 246px;
`;

export const MyPropertyIconContainer = styled.div`
  height: 150px;
  text-align: center;
`;

export const MyPropertyIcon = styled.div`
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MyPropertyFactsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 113px;
  width: 100%;
`;

export const MyPropertyBanner = styled(Text)`
  background-color: ${token('colors.brand')};
  color: ${token('white')};
  width: 100%;
  text-align: center;
  border-radius: 4px;
`;
